import React from 'react';

function Ticker({ news, onOpen }) {
  if (!news || news.length === 0) return null;
  const items = news.slice(0, 6);

  return (
    <div className="bg-amber-300 text-ink flex items-center overflow-hidden w-full">
      <span className="flex-shrink-0 bg-crimson text-white text-[14px] font-bold tracking-[0.04em] px-4 py-2.5">ताजा</span>
      <div className="flex-1 overflow-hidden">
        <div className="animate-marquee flex w-max">
          {[...items, ...items].map((n, i) => (
            <span
              key={`${n.id}-${i}`}
              className={`text-[15px] font-medium py-2.5 pr-8 whitespace-nowrap opacity-80 hover:opacity-100 hover:underline cursor-pointer ${i % 2 === 0 ? 'hover:text-crimson' : 'hover:text-green-800'}`}
              onClick={() => onOpen(n)}
              role="button"
              tabIndex={0}
            >
              {n.title}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Ticker;